import type { PlanCell, RawPlanCell } from '../types/plan';

/**
 * Normalize plan cells from API response.
 * CN-0012: Now using global coordinates directly (row, col).
 * Backend sends row/col as global coordinates.
 */
export const normalizePlanCells = (cells: RawPlanCell[] = []): PlanCell[] => {
  return cells
    .map((cell) => {
      // CN-0012: Use row/col directly as global coordinates
      // Support both camelCase and snake_case from backend
      const row = cell.row ?? cell.row_world;
      const col = cell.col ?? cell.col_world;
      
      if (!row || !col || !cell.kind) return null;
      
      return {
        row,
        col,
        kind: cell.kind,
        bedId: cell.bedId ?? cell.bed_id ?? null,
        plotId: cell.plotId ?? cell.plot_id ?? null,
        structuralObjectId: cell.structuralObjectId ?? cell.structural_object_id ?? null,
      } as PlanCell;
    })
    .filter(Boolean) as PlanCell[];
};

export const planCellKey = (row: number, col: number): string => `${row}:${col}`;
